import { createFileRoute, redirect } from "@tanstack/react-router";
import { Onboarding } from "@/features/onboarding/onboarding";
import { ensureMe } from "@/hooks/data";
import { isApiError } from "@/lib/api/errors";
import { adoptSession } from "@/lib/auth";

/** First-run wizard, outside the app shell. Needs a session (and an org). */
export const Route = createFileRoute("/onboarding")({
  beforeLoad: async ({ context }) => {
    try {
      const me = await ensureMe(context.queryClient);
      // onboarding needs a current org: a login with no organization creates one first
      if (!adoptSession(me)) throw redirect({ to: "/create-org" });
    } catch (e) {
      if (isApiError(e) && e.isUnauthorized) throw redirect({ to: "/login", search: { redirect: "/onboarding" } });
      throw e;
    }
  },
  head: () => ({ meta: [{ title: "Welcome · Malfak" }] }),
  component: Onboarding,
});
